// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_CriarAcessoPortalInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /clientes/criar-acesso-portal
 *
 * Staff-facing: creates a portal login (my.newshoes.com) for one cliente.
 *
 * The body carries only the cliente_id. The document is deliberately NOT
 * accepted from the client — it is read from the cliente record the caller
 * is allowed to see, so a caller cannot provision an account for a document
 * of their choosing.
 */
import { registerContract } from './validate'

export interface Clientes_CriarAcessoPortalInput {
cliente_id: number
}

registerContract('Clientes_CriarAcessoPortalInput', {
  cliente_id: { type: 'number',  required: true },
})
